import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { SubscriptionDuration, SubscriptionType } from '../../types/plan.types';
import { useAppQuery } from '../use-app-query.hook';

export type BasicPlan = {
  duration: SubscriptionDuration;
  id: string;
  priceInCents: number;
  stakeholdersCount: number;
  title?: string;
  type?: SubscriptionType;
};

// tenant: global — system (Stripe-configured) prices for the standard plans, a public catalog
// endpoint with no owning tenant, so it is not a companies/:companyId sub-resource. The offer
// modal displays these prices read-only when Startup/Growth is selected.

// Stable fallback — consumers use `plans` in effect dependency arrays, so a fresh `[]` per
// render would re-fire those effects forever.
const NO_PLANS: BasicPlan[] = [];

export const useBasicPlans = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { data, isLoading } = useAppQuery<BasicPlan[]>({
    queryKey: [QueryKey.GET_BASIC_PLANS],
    queryFn: () =>
      ApiService.get<BasicPlan[]>(
        { endpoint: BackendRoute.PLANS, routePath: ['basic'] },
        { regularBackend: true },
      ),
    enabled,
  });

  return { plans: data ?? NO_PLANS, isLoading };
};
